import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Tree from 'react-d3-tree';
import { useJwt } from "react-jwt";
import { GetAllProfile, GetRoleById, GetRoleTree, GetValidParentsRole, UpdateRole } from '../apiconfig/authService';

function EditRole(props) {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const setRoleViewMessage = props.setMessage;

    const [message, setMessage] = useState('');
    const [isMessageRed, setIsMessageRed] = useState(false);

    const [roleData, setRoleData] = useState({});
    const [editedRoleData, setEditedRoleData] = useState({});
    const [treeData, setTreeData] = useState({});
    const [rolesData, setRolesData] = useState([]);
    const [profilesData, setProfilesData] = useState([]);
    const { roleid } = useParams();

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetRoleById(roleid, localStorage.getItem('accessToken'));
                    setRoleData(response.data);
                    setEditedRoleData(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);

    const handleRoleNameChange = (e) => {
        const temp = { ...editedRoleData };
        temp.rolename = e.target.value;
        setEditedRoleData(temp);
    };

    const handleRoleDescriptionChange = (e) => {
        const temp = { ...editedRoleData };
        temp.roledescription = e.target.value;
        setEditedRoleData(temp);
    };

    const handleRoleParentIDChange = (e) => {
        const temp = { ...editedRoleData };
        temp.roleparentid = e.target.value;
        setEditedRoleData(temp);
    };

    const handleRoleProfileIDChange = (e) => {
        const temp = { ...editedRoleData };
        temp.roleprofileid = e.target.value;
        setEditedRoleData(temp);
    };

    const handleDiscardClick = () => {
        const temp = { ...roleData };
        setEditedRoleData(temp);
    };

    const validateInput = () => {
        if (editedRoleData.rolename === '')
            throw new Error('Role Name is required.');
    };


    const handleSubmitClick = async (e) => {
        e.preventDefault();

        try {
            validateInput();
        } catch (error) {
            setIsMessageRed(true);
            setMessage(error.message);
            window.scrollTo(0, 0);
            return;
        }

        let response;

        try {
            response = await UpdateRole({
                roleid,
                rolename: editedRoleData.rolename,
                roleparentid: editedRoleData.roleparentid,
                roleprofileid: editedRoleData.roleprofileid,
                roledescription: editedRoleData.roledescription,
            }, localStorage.getItem('accessToken'));
            if (response.status === 200) {
                setRoleViewMessage(response.data.message);
                navigate('/role');
            }
        } catch (err) {
            if ((err.response && err.response.data) && err.response.data.error) {
                setIsMessageRed(true);
                setMessage(err.response.data.error);
                window.scrollTo(0, 0);
            } else {
                setIsMessageRed(true);
                setMessage('An error occurred. Please try again later.');
                window.scrollTo(0, 0);
            }
            console.log(err);
        }
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetRoleTree(localStorage.getItem('accessToken'));
                    setTreeData(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
        (
            async () => {
                try {
                    const response = await GetAllProfile(localStorage.getItem('accessToken'));
                    setProfilesData(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
        (
            async () => {
                try {
                    const rolesResponse = await GetValidParentsRole(localStorage.getItem('accessToken'));
                    setRolesData(rolesResponse.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);

    const renderCustomNode = ({ nodeDatum, toggleNode }) => {
        const isHighlighted = roleData && nodeDatum.name === roleData.rolename;
        return (
            <g>
                <circle
                    r={15}
                    fill={isHighlighted ? 'yellow' : 'steelblue'}
                    strokeWidth='1'
                />
                <text
                    x={-20}
                    y={5}
                    textAnchor="end"
                    fontSize="12px"
                    fontWeight="small"
                    fill='black'
                    style={{ cursor: 'pointer', stroke: 'black', strokeWidth: 0.5 }}
                >
                    {nodeDatum.name}
                </text>
            </g>
        );
    };

    return (
        <div className="dashboard-content">
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Edit Role</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/role" className="btn btn-primary">View All</NavLink>
                    </div>
                </div>

                {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}

                <div role="tabpanel" className="personal-info tab-pane active" id="pi">
                    <h4 className="text-primary h6 fw-bold">Role's Position in Hierarchy</h4>
                    {treeData &&
                        <div id="treeWrapper" style={{ width: '50em', height: '20em' }}>
                            <Tree data={treeData} renderCustomNodeElement={renderCustomNode} />
                        </div>
                    }
                    <h4 className="text-primary h6 fw-bold">Role Information</h4>
                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-6 mb-3">
                            <div className="form-floating">
                                <select className="form-select" value={editedRoleData.roleparentid} onChange={handleRoleParentIDChange}>
                                    {
                                        rolesData?.map((item) => (
                                            <option value={item.roleid}>
                                                {item.rolename}
                                            </option>
                                        ))
                                    }
                                </select>
                                <label htmlFor="floatingInput">Select Parent</label>
                            </div>
                        </div>
                        <div className="form-group col-sm-12 col-lg-6 mb-3">
                            <div className="form-floating mb-4">
                                <input type="text" value={editedRoleData.rolename} onChange={handleRoleNameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                                <label htmlFor="catName">Role Name</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-6 mb-3">
                            <div className="form-floating">
                                <select className="form-select" onChange={handleRoleProfileIDChange} value={editedRoleData.roleprofileid}>
                                    {
                                        profilesData?.map((item) => (
                                            <option value={item.profileid}>
                                                {item.profilename}
                                            </option>
                                        ))
                                    }
                                </select>
                                <label htmlFor="floatingInput">Select Role's Profile</label>
                            </div>
                        </div>
                        <div className="form-group col-sm-12 col-lg-6 mb-3">
                            <div className="form-floating mb-4">
                                <input type="text" value={editedRoleData.roledescription} onChange={handleRoleDescriptionChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                                <label htmlFor="catName">Role Description</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-sm-12 col-lg-12 mb-3">
                            <button type="submit" onClick={handleDiscardClick} className="btn btn-danger btn-lg save-btn text-uppercase">Discard</button> &nbsp;
                            <button type="submit" onClick={handleSubmitClick} className="btn btn-primary btn-lg save-btn text-uppercase">Save</button>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    );
}
export default EditRole;
